module.exports = {"domain":"/","domainbak":"https://wisdom.ordosdx.cn/","serviceBase":"_api/school/","ssoBase":"_api/sso/","websocketBase":"_api/school/","specialFlag":"/#","schoolLeaderUserCode":"leader","leaderUserCode":"eas-l","easUserCode":"eas","teacherClassUserCode":"teacherClazz","teacherUserCode":"teacher","studentUserCode":"student","manageCode":"man","cateringCode":"catering"}


//////////////////
// WEBPACK FOOTER
// ./src/json/data.json
// module id = 30fl
// module chunks = 1